export const hasPermission = (permissions, permission) => {
  const p = permissions.find(per => per.authority === permission)
  return p !== undefined
}
